import React from "react";
import { Component } from "react";
import "../../styles/components/eagleView.scss"
import { imageAddress, translate } from "../../utils/useful";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';


class Monitor extends Component {

    state = {}

    render() {
        return (

            <aside className="monitor-responsive-banner second px-2 py-1">
                <div className="monitor-container-envelope">

                    <svg className="cirle-a circle-svg" height="160" width="160">
                        <circle cx="80" cy="80" r="80" />
                    </svg>

                    <svg className="cirle-b circle-svg" height="60" width="60">
                        <circle cx="30" cy="30" r="30" />

                    </svg>
                    <svg className="cirle-c circle-svg" height="600" width="600">
                        <circle cx="300" cy="300" r="300" />

                    </svg>
                    <svg className="cirle-d circle-svg" height="60" width="60">
                        <circle cx="30" cy="30" r="30" />
                    </svg>
                    <div>
                        <div className="col-xs-12">
                            <div className="flexc">
                                <div style={{ position: 'relative' }} >
                                    <img className="br-50" style={{ width: '60px', height: '60px', borderRadius: '100px', objectFit: 'cover', border: '2px solid #ffffff90' }} src={imageAddress(this.props.user?.info?.image, 'profile', 'thumb')} />
                                    <div style={{ position: 'absolute', bottom: -5, right: -5 }}>
                                        {/* <div style={{ height: 20, objectFit: 'cover', borderRadius: 100, background: '#ee5050', width: "20px" }} /> */}
                                        <img src={imageAddress(this.props.applet?.image, 'profile', 'mini')} width="35px" style={{ height: 35, borderRadius: 100, objectFit: 'cover', border: '2px solid #ffffff99' }} />
                                    </div>

                                </div>
                                <div className="pld-3" style={{ flexDirection: 'column' }}>
                                    <p className="mt-0 mb-1 text-normal text-bold color-gray-1" style={{ color: '#ffffff' }} >{translate('Booking')}</p>
                                    <p className="text-small" style={{ color: '#ffffff' }}>{this.props.user?.info?.fullname}</p>
                                </div>
                                {/* {this.props.lastStage && (
                                    <button onClick={()=> this.props.lastStage()}>
                                        Back
                                    </button>
                                )} */}
                            </div>
                        </div>
                        {this.props.showNotification == true &&
                            <div className="col-xs-12">
                                <div className="flexc mt-3 pld-2">
                                    {/* notification number */}
                                    <span className="request-num mx-1"><a target="_blank">1</a></span>
                                    <img className="invert mrd-1" src="/assets/icons/notification.svg" style={{ width: '20px', position: 'sticky' }} />
                                    <p className="alert-requests">{this.props.title}</p>
                                </div>
                                <div className="mld-5" onClick={() => this.props.showRequests()}>
                                    <a target="_blank" className="monitor-more-link" >{this.props.button}</a>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </aside >

        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Monitor);